import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import regionReducer from "../features/counter/RegionSlice";
import kycReducer from '../features/counter/kycSlice.js';
import userReducer from "../features/counter/userSlice.js";
import authReducer from '../features/counter/Authslice.js';


const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['kyc', 'client'] 
};

const rootReducer = combineReducers({
  auth: authReducer,
  region: regionReducer,
  kyc: kycReducer,
  user: userReducer,
  
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(thunk),
});

export const persistor = persistStore(store);
